/* eslint-disable camelcase */

import ShopNavigationMenu from './ShopNavigationMenu';

export * from './model';
export * from './fetchShopNavigationMenu';
export default ShopNavigationMenu;

